import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const getToken = () => localStorage.getItem("ts_admin_token");
export const setToken = (t) => localStorage.setItem("ts_admin_token", t);
export const clearToken = () => localStorage.removeItem("ts_admin_token");

export const adminApi = axios.create({ baseURL: API });
adminApi.interceptors.request.use((c) => {
  const t = getToken();
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});

export const formatErr = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg || JSON.stringify(x)).join(" ");
  return e?.message || "Something went wrong";
};
